import { Box, Typography, Link } from "@mui/material";
import React from "react";
import LogoEma from "../../assets/images/logoEma2.png";
import LogoTUV from "../../assets/images/logoTUV.png";
import LogoElectromechanics from "../../assets/images/logoElectromechanics.png";
import LogoEmaServicios from "../../assets/images/logoEmaServicios.png";
import { WorkspacePremium } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const {t} = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", md: "flex-start" },
        position: "relative", // Esto asegura que el header esté fijo
        flexWrap: "wrap", // permite que los bloques bajen si no hay espacio
        width: "100%",
        py: { xs: 4, md: 8 },
        px: { xs: 3, md: "12%" },
        background: "#F0F0F0",
        gap: { xs: 4, md: 0 },
      }}
    >
      {/* Logo + dirección */}
      <Box sx={{ flex: "1 1 250px" }}>
        <img
          src={LogoEma}
          alt="Logo ema gabi"
          style={{ maxWidth: "180px", height: "auto" }}
        />
        <Box sx={{ maxWidth: "20rem", mt: 2 }}>
          <Typography
            sx={{
              color: "#1B2466",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: { xs: "14px", sm: "15px" },
              fontWeight: 600,
              mb: 1,
            }}
          >
            Av. San Martin 4970 B1604CDX Florida, Buenos Aires, Argentina
          </Typography>
          <Typography
            sx={{
              color: "#1B2466",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: { xs: "14px", sm: "15px" },
              fontWeight: 600,
              mb: 1,
            }}
          >
            Tel: +54 11 4760-0054 / +54 11 4760-0052
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }}>
            <Typography
              sx={{
                color: "#1B2466",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: { xs: "14px", sm: "15px" },
                fontWeight: 600,
              }}
            >
              Mail:
            </Typography>
            <Link
              href="mailto:contacto@ema.com.ar"
              underline="hover"
              sx={{
                color: "#1B2466",
                fontSize: { xs: "14px", sm: "15px" },
                fontWeight: 600,
              }}
            >
              contacto@ema.com.ar
            </Link>
            <Typography sx={{ color: "#1B2466" }}> / </Typography>
            <Link
              href="mailto:gcom@ema.com.ar"
              underline="hover"
              sx={{
                color: "#1B2466",
                fontSize: { xs: "14px", sm: "15px" },
                fontWeight: 600,
              }}
            >
              gcom@ema.com.ar
            </Link>
          </Box>
        </Box>
      </Box>

      {/* Otras empresas */}
      <Box sx={{ flex: "1 1 200px", display: "flex", flexDirection: "column" }}>
        <Typography
          sx={{
            mt: 1,
            color: "#1B2466",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: { xs: "14px", sm: "15px" },
            fontWeight: 600,
          }}
        >
          {t("otras_empresas")}
        </Typography>
        <Link
          href="https://emaelectromechanics.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={LogoElectromechanics}
            alt="Logo Electromechanics"
            style={{ maxWidth: "160px", marginTop: "1rem" }}
          />
        </Link>
        <Link
          href="https://www.emaservicios.com.ar/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={LogoEmaServicios}
            alt="Logo Ema Servicios"
            style={{ maxWidth: "160px", marginTop: "1rem" }}
          />
        </Link>
      </Box>

      {/* Certificados */}
      <Box sx={{ flex: "1 1 250px" }}>
        <Typography
          sx={{
            maxWidth: "90%",
            mt: 1,
            color: "#1B2466",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: { xs: "14px", sm: "15px" },
            fontWeight: 600,
          }}
        >
          {t("certificados")}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", mt: 2, gap: 1 }}>
          <Link
            href="https://ema.com.ar/assets/docs/ISO9001.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <WorkspacePremium sx={{ color: "#1B2466" }} />
              <Typography
                sx={{
                  color: "#1B2466",
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: { xs: "14px", sm: "15px" },
                  fontWeight: 600,
                  textDecoration: "underline",
                }}
              >
                {t("certificado_iso")}
              </Typography>
            </Box>
          </Link>
          <Link
            href="https://ema.com.ar/assets/docs/Politicas-de-gestion.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <WorkspacePremium sx={{ color: "#1B2466" }} />
              <Typography
                sx={{
                  color: "#1B2466",
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: { xs: "14px", sm: "15px" },
                  fontWeight: 600,
                  textDecoration: "underline",
                }}
              >
                {t("politicas_de_gestion")}
              </Typography>
            </Box>
          </Link>
        </Box>
        <Box sx={{ mt: 2 }}>
          <img
            src={LogoTUV}
            alt="Logo TUV"
            style={{ maxWidth: "180px", height: "auto" }}
          />
        </Box>
      </Box>
    </Box>
  );
};
